import React, { useState } from "react";
import Card from "../cards/Card";
import AdminPagination from "../Pageination/AdminPagination";
import { BtnAlternative } from "../buttons/Btn";
import { Modal } from "../modal/Modal";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import TableSort from "./TableSort/TableSort";

function CoustomTable(props) {
    //const { items, requestSort, sortConfig } = TableSort(props.list);
    const [priority, setPriority] = useState(false);
    const [priorityid, setPriorityid] = useState([]);
    const [priorityid1, setPriorityid1] = useState(1);
    const handleClick = (id) => {
        setPriorityid1(id);

        if (id < 5) {
            setPriorityid((prev) => [...prev, id]);
        }
        if (priorityid.includes(id)) {
            setPriorityid(priorityid.filter((el) => el !== id));
        }
    };
    const handleremove = (id) => {
        setPriorityid(priorityid.filter((el) => el !== id));
        setPriorityid1(id);
    };

    return (
        <div className="mx-5 ">
            {props.priority && priorityid1 < 5 && (
                <p className=" text-[#B00020] font-normal text-[1.2rem] leading-[2.4rem] mb-[0.3rem] pr-[0.5rem]">
                    *شما هنوز اولویت{" "}
                    <span>
                        {!priorityid.includes(1)
                            ? "اول"
                            : !priorityid.includes(2)
                            ? "دوم"
                            : !priorityid.includes(3)
                            ? "سوم"
                            : !priorityid.includes(4) && "چهارم"}
                    </span>{" "}
                    خود را ثبت نکرده اید!
                </p>
            )}
            <Card className="SupportTicketTable-card SupportTicketTable-header ">
                {props.header.map((item, id) => (
                    <div
                        className={
                            props.sort &&
                            props.num === id &&
                            ` cursor-pointer flex flex-row items-center`
                        }
                        //onClick={() => props.num === id && requestSort("id")}
                    >
                        {item.title}
                        {/* {props.sort &&
                            props.num === id &&
                            (sortConfig?.direction === "ascending" ? (
                                <AiOutlineDown className=" mr-[0.3rem]" />
                            ) : (
                                <AiOutlineUp className=" mr-[0.3rem]" />
                            ))} */}
                    </div>
                ))}
            </Card>
            {props.list.map((i, id) => (
                <Card
                    key={i?.id}
                    className="SupportTicketTable-card SupportTicketTable-body my-4"
                >
                    <div
                        className="cursor-pointer underline"
                        style={{
                            color: i?.name === "برداشت" ? "brown" : "green",
                        }}
                        onClick={props.showModal}
                    >
                        {i?.name}
                    </div>
                    <p>{i?.date}</p>
                    {props.priority === null ? (
                        <div>{i?.test}</div>
                    ) : props.priority ? (
                        <div
                            onClick={() => handleClick(i.id)}
                            className="cursor-pointer w-full flex items-center flex-row justify-between"
                        >
                            {i.id < 5 && priorityid.includes(i.id) && i.id}
                            <div className=" opacity-0">aaaa</div>
                            {priorityid.includes(i.id) && (
                                <p
                                    className=" text-[#B00020] font-normal text-[1rem] leading-[1.5rem] cursor-pointer"
                                    onClick={() => handleremove(i.id)}
                                >
                                    حذف اولویت
                                </p>
                            )}
                        </div>
                    ) : (
                        !props.priority && <div>{i.id}</div>
                    )}
                    <div>
                        {i?.btn && props.lightbtn && (
                            <div className="flex">
                                <BtnAlternative
                                    text={i.btn}
                                    className="px-10 py-6 self-center"
                                    onClick={props.showModal}
                                />
                            </div>
                        )}
                        {i?.btn && !props.lightbtn && <p>{i.btn}</p>}
                        <div>{i?.price}</div>
                    </div>
                </Card>
            ))}
            {props.children}
        </div>
    );
}

export default CoustomTable;
